import { render } from "./BaseWrapper.vue?vue&type=template&id=3de3e846&scoped=true&ts=true"
import script from "./BaseWrapper.vue?vue&type=script&lang=ts"
export * from "./BaseWrapper.vue?vue&type=script&lang=ts"

import "./BaseWrapper.vue?vue&type=style&index=0&id=3de3e846&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de3e846"]])

export default __exports__